import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Payload {
  id: string;
  description?: string;
  name: string;
}

const useUpdateLmnItemQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    (payload: Payload) =>
      api.patch(API_URL.LETTERS_OF_MEDICAL_NECESSITY_BY_ID(payload.id), {
        description: payload.description || undefined,
        name: payload.name,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.LETTERS_OF_MEDICAL_NECESSITY],
        });
      },
    }
  );

  return {
    updateLMN: mutateAsync,
    isLoading,
  };
};

export default useUpdateLmnItemQuery;
